import React from 'react'
import {
    Subject,
    ThumbUpAlt,
    Star,
    ChatBubble,
    Share
} from "styled-icons/material";

const playerNavigation = () => {

    return (
        <div className="player-actions hide-on-med-and-down">
            <ul>
                <li>
                    <Subject className="player-actions_icon" />
                </li>
                <li className="active">
                    <ThumbUpAlt className="player-actions_icon player-actions_icon_active" />
                </li>
                <li className="active">
                    <Star className="player-actions_icon player-actions_icon_active" />
                </li>
                <li>
                    <ChatBubble className="player-actions_icon" />
                </li>
                <li>
                    <Share className="player-actions_icon" />
                </li>
            </ul>
        </div>
    )
}

export default playerNavigation
